import { render, staticRenderFns } from "./RestoreValueButton.vue?vue&type=template&id=3f16d0b4&scoped=true&"
import script from "./RestoreValueButton.vue?vue&type=script&lang=js&"
export * from "./RestoreValueButton.vue?vue&type=script&lang=js&"
import style0 from "./RestoreValueButton.vue?vue&type=style&index=0&id=3f16d0b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f16d0b4",
  null
  
)

export default component.exports